import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { isDark } = useTheme();
  const { i18n } = useTranslation();

  const isJapanese = i18n.language === 'ja';

  const toggleLanguage = () => {
    const newLang = isJapanese ? 'en' : 'ja';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="fixed top-20 md:top-24 left-2 md:left-6 z-[60] flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 hover:scale-105"
      style={{
        backgroundColor: isDark ? 'rgba(20, 20, 20, 0.9)' : 'rgba(255, 255, 255, 0.95)',
        border: `2px solid ${isDark ? '#00ffff' : '#0ea5e9'}`,
        boxShadow: isDark 
          ? '0 4px 20px rgba(0, 255, 255, 0.3)' 
          : '0 4px 20px rgba(14, 165, 233, 0.2)'
      }}
      data-testid="language-toggle"
      title={isJapanese ? 'Switch to English' : '日本語に切り替え'}
    >
      {/* Globe Icon */}
      <Globe 
        className="w-4 h-4" 
        style={{ color: isDark ? '#00ffff' : '#0ea5e9' }} 
      />
      
      {/* EN side */}
      <span 
        className="text-sm font-bold px-2 py-1 rounded-full transition-all duration-300"
        style={{
          backgroundColor: !isJapanese 
            ? (isDark ? '#00ffff' : '#0ea5e9') 
            : 'transparent',
          color: !isJapanese 
            ? (isDark ? '#000' : '#fff') 
            : (isDark ? '#666' : '#94a3b8')
        }}
      >
        EN
      </span>
      
      {/* Divider */}
      <span 
        className="text-sm"
        style={{ color: isDark ? '#444' : '#cbd5e1' }}
      >
        |
      </span>
      
      {/* JP side */}
      <span 
        className="text-sm font-bold px-2 py-1 rounded-full transition-all duration-300"
        style={{
          backgroundColor: isJapanese 
            ? (isDark ? '#ff00ff' : '#d946ef') 
            : 'transparent',
          color: isJapanese 
            ? '#fff' 
            : (isDark ? '#666' : '#94a3b8')
        }}
      >
        JP
      </span>
    </button>
  );
};

export default LanguageToggle;
